import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import logo_white from "../../../../assets/brand/pentalens-white.jpg";
import logo_dark from "../../../../assets/brand/pentalens-dark.png";
import OneNavLink from "../components/OneNavLink";
import { ItemsProjectReviewSystem } from "../items-of-dropdown/ItemsProjectReviewSystem";
import OneWithoutNavLnk from "../components/OneWithoutNavLnk";
import { AbstructVar } from "../../../general/general-component/abstruct-component/AbstructVar";
import { AbstructLang } from "../../../general/general-component/abstruct-component/AbstructLang";
import useClickOutside from "../../../../useClickOutside";
import { AuthLogout } from "../../../../store/Actions/ActionAuth";
import { useSelectorCustom } from "../../../general/general-component/abstruct-component/useSelectorCustom";
import ItemsWarehouse from "../items-of-dropdown/ItemsWarehouse";
import ItemsAccounting from "../items-of-dropdown/ItemsAccounting";
import {
  UsePermissions,
  hasPermissions,
} from "../../../general/general-component/abstruct-component/UsePermissions";

const Sidebar = ({ sidebarOpen, closeSidebar }) => {
  let { dispatch, navigate, langLocal, mode } = AbstructVar();
  const { mainPermission } = useSelectorCustom();
  const { translate } = AbstructLang();
  const { items } = ItemsProjectReviewSystem();
  const [scripts, setscripts] = useState(items);
  const { itemsWarehouse } = ItemsWarehouse();
  const { itemsAccounting } = ItemsAccounting();
  const [accountss, setAccountss] = useState(itemsAccounting);
  const [warehousesItems, setWarehousesItems] = useState(itemsWarehouse);
  //const { itemsE } = ItemsEvaluationSystem()
  const { permissionss } = UsePermissions();
  const dashboard = hasPermissions([{ name: "dashboard" }], permissionss);
  const projects = hasPermissions([{ name: "projects" }], permissionss);
  const users = hasPermissions([{ name: "users" }], permissionss);
  const visitors = hasPermissions([{ name: "visitors" }], permissionss);
  const warehouses = hasPermissions([{ name: "warehouses" }], permissionss);
  const materials = hasPermissions([{ name: "materials" }], permissionss);
  const accounts = hasPermissions([{ name: "accounts" }], permissionss);
  const expenses = hasPermissions([{ name: "expenses" }], permissionss);
  const expenses_statements = hasPermissions(
    [{ name: "expenses-statements" }],
    permissionss
  );
  const expenses_transactions = hasPermissions(
    [{ name: "expenses-transactions" }],
    permissionss
  );
  const project_types = hasPermissions(
    [{ name: "project-types" }],
    permissionss
  );
  const project_requests = hasPermissions(
    [{ name: "project-requests" }],
    permissionss
  );
  const evaluation_types = hasPermissions(
    [{ name: "evaluation-types" }],
    permissionss
  );
  const settings = hasPermissions([{ name: "settings" }], permissionss);
  const notifications = hasPermissions(
    [{ name: "notifications" }],
    permissionss
  );
  const rolesPer = hasPermissions([{ name: "roles" }], permissionss);
  const suppliers = hasPermissions([{ name: "suppliers" }], permissionss);
  const accounting_settings = hasPermissions(
    [{ name: "accounting-settings" }],
    permissionss
  );
  const script_archive = hasPermissions(
    [{ name: "script-archive" }],
    permissionss
  );
  const requests = hasPermissions([{ name: "requests" }], permissionss);

  useEffect(() => {
    let updatedItems = [...items];

    if (!project_types) {
      updatedItems = updatedItems.filter((item) => item.id !== 1);
    }
    if (!project_requests) {
      updatedItems = updatedItems.filter((item) => item.id !== 2);
    }
    if (!evaluation_types) {
      updatedItems = updatedItems.filter((item) => item.id !== 3);
    }
    if (!script_archive) {
      updatedItems = updatedItems.filter((item) => item.id !== 4);
    }

    setscripts(updatedItems);
  }, [
    project_types,
    script_archive,
    project_requests,
    evaluation_types,
    langLocal,
  ]);
  useEffect(() => {
    let updatedItems = [...itemsAccounting];

    if (!accounts) {
      updatedItems = updatedItems.filter((item) => item.id !== 1);
    }
    if (!expenses_transactions) {
      updatedItems = updatedItems.filter((item) => item.id !== 2);
    }
    if (!expenses_statements) {
      updatedItems = updatedItems.filter((item) => item.id !== 3);
    }
    if (!expenses) {
      updatedItems = updatedItems.filter((item) => item.id !== 4);
    }
    if (!accounting_settings) {
      updatedItems = updatedItems.filter((item) => item.id !== 5);
    }

    setAccountss(updatedItems);
  }, [
    accounts,
    expenses,
    expenses_statements,
    expenses_transactions,
    accounting_settings,
    langLocal,
  ]);
  useEffect(() => {
    let updatedItems = [...itemsWarehouse];
    if (!warehouses) {
      updatedItems = updatedItems.filter((item) => item.id !== 1);
    }
    if (!suppliers) {
      updatedItems = updatedItems.filter((item) => item.id !== 3);
    }
    if (!materials) {
      updatedItems = updatedItems.filter((item) => item.id !== 2);
    }
    if (!requests) {
      updatedItems = updatedItems.filter((item) => item.id !== 4);
    }

    setWarehousesItems(updatedItems);
  }, [suppliers, warehouses, materials, requests, langLocal]);

  const logout = (event) => {
    event.preventDefault();
    dispatch(AuthLogout(navigate));
  };

  let domNode = useClickOutside(() => {
    closeSidebar();
  });

  return (
    <div
      className={sidebarOpen ? "sidebar_responsive" : ""}
      id={langLocal == "ar" ? "sidebar_ar" : "sidebar_en"}
      ref={domNode}
    >
      <div className="sidebar_title" dir={langLocal == "ar" ? "rtl" : "ltr"}>
        <i
          className="fa fa-times"
          id="sidebarIcon"
          onClick={() => closeSidebar()}
        ></i>
        <div className="sidebar_img">
          {mode === "dark" ? <img src={logo_dark} /> : <img src={logo_white} />}
        </div>
      </div>
      <div className="sidebar_menu">
        {dashboard && (
          <OneNavLink
            colorIcon="--pink"
            url="/"
            title={translate("dashboard")}
            icon="fa fa-home"
            langLocal={langLocal}
          />
        )}

        {scripts?.length > 0 && (
          <OneWithoutNavLnk
            colorIcon="--blue"
            title={translate("Projects")}
            icon="fas fa-project-diagram"
            langLocal={langLocal}
            items={scripts}
            arrow={true}
          />
        )}
        {warehousesItems?.length > 0 && (
          <OneWithoutNavLnk
            colorIcon="--yellow"
            title={translate("warehouses")}
            icon="fas fa-warehouse"
            langLocal={langLocal}
            items={warehousesItems}
            arrow={true}
          />
        )}
        {accountss?.length > 0 && (
          <OneWithoutNavLnk
            colorIcon="--green"
            title={translate("accounting")}
            icon="fas fa-coins"
            langLocal={langLocal}
            items={accountss}
            arrow={true}
          />
        )}

        {users && (
          <OneNavLink
            colorIcon="--purpule"
            url="/users"
            title={translate("users")}
            icon="fa fa-user"
            langLocal={langLocal}
          />
        )}
        {visitors && (
          <OneNavLink
            colorIcon="--blue"
            url="/visitors"
            title={translate("Visitors")}
            icon="fa fa-users"
            langLocal={langLocal}
          />
        )}

        {notifications && (
          <OneNavLink
            colorIcon="--yellow"
            url="/notifications"
            title={translate("Notifications")}
            icon="fa-solid fa-bell"
            langLocal={langLocal}
          />
        )}
        {rolesPer && (
          <OneNavLink
            colorIcon="--green"
            url="/roles"
            title={translate("Roles And Permissions")}
            icon="fa-solid fa-users-gear"
            langLocal={langLocal}
          />
        )}

        {/* <OneNavLink
          colorIcon="--purpule"
          url="/vcards"
          title={translate("vcard")}
          icon="fa fa-vcard"
          langLocal={langLocal}
        /> */}

        {settings && (
          <OneNavLink
            colorIcon="--pink"
            url="/settings"
            title={translate("Settings")}
            icon="fa fa-gear"
            langLocal={langLocal}
          />
        )}

        <div
          dir={langLocal == "ar" ? "rtl" : "ltr"}
          className="sidebar_logout"
          onClick={logout}
        >
          <i className="fa fa-power-off"></i>
          <a href="#">{translate("logout")}</a>
        </div>
        <br></br>
        <br></br>
      </div>
    </div>
  );
};
<i class="fa-solid fa-person"></i>;
export default Sidebar;
